import _ from 'lodash';

import {
  COMPANY_DETAIL_URL,
  INVESTOR_DETAIL_URL,
  SERVICE_PROVIDER_DETAIL_URL
} from 'global-constants';

import { getUserCompanyName } from 'shared/utils/common';
import { substituteUrl } from 'shared/utils/substituteUrl';

export const getInfluencerFullName = influencer => {
  const first_name = _.get(influencer, 'profile.first_name', '');
  const surname = _.get(influencer, 'profile.surname', '');

  return `${first_name} ${surname}`;
};

export const getInfluencerPosition = influencer => {
  const membershipType = _.get(influencer, 'membership_type.label');
  const position = _.get(influencer, 'profile.position.name', membershipType);

  return position;
};

export const getOccupation = influencer => {
  const position = getInfluencerPosition(influencer);
  const { vendor, service_provider: serviceProvider, investor } = influencer;

  const doesNotHaveCompany =
    _.isNil(vendor) && _.isNil(serviceProvider) && _.isNil(investor);

  if (doesNotHaveCompany) {
    return '';
  }

  let companyName;

  if (vendor) {
    companyName = vendor.name;
  } else if (serviceProvider) {
    companyName = serviceProvider.name;
  } else {
    companyName = investor.name;
  }

  if (position) {
    return `${position} at ${companyName}`;
  }

  return companyName;
};

export const getInfluencerOccupation = (
  influencer,
  divider = ' | ',
  showVendor = true
) => {
  if (!getUserCompanyName(influencer) && showVendor) {
    return '';
  }

  const position = getInfluencerPosition(influencer);

  if (!showVendor) {
    return position;
  }
  const vendorName = getUserCompanyName(influencer);

  return [position, vendorName].filter(el => !_.isNil(el)).join(divider);
};

export const redirectToUserCompany = ({ user, push }) => {
  const companySlug = _.get(user, 'vendor.slug');
  const serviceProviderSlug = _.get(user, 'service_provider.slug');
  const investorSlug = _.get(user, 'investor.slug');

  if (companySlug) {
    push(substituteUrl(COMPANY_DETAIL_URL, { companySlug }));
  } else if (serviceProviderSlug) {
    push(substituteUrl(SERVICE_PROVIDER_DETAIL_URL, { serviceProviderSlug }));
  } else if (investorSlug) {
    push(substituteUrl(INVESTOR_DETAIL_URL, { investorSlug }));
  }
};
